// deps
import { useCallback, useContext } from "react";

//analytics
import { onImpressionBTCToggle } from "@payment-client/analytics/events/BillToCompany";

//internal-deps
import { AnalyticsContext } from "@swiggy-private/checkout-core";

interface useBillToCompanyAnalyticsHandlerReturn {
    onImpressionBTCToggle: (selected: boolean, context: string) => void;
}

interface useBillToCompanyAnalyticsProps {
    screenName?: string;
}

const useBillToCompanyAnalyticsHandler = ({
    screenName,
}: useBillToCompanyAnalyticsProps): useBillToCompanyAnalyticsHandlerReturn => {
    const { impressionEvent } = useContext(AnalyticsContext);

    const _onImpressionBTCToggle = useCallback(
        (selected: boolean, context: string) => {
            onImpressionBTCToggle(impressionEvent, selected, context, screenName);
        },
        [impressionEvent, screenName],
    );

    return {
        onImpressionBTCToggle: _onImpressionBTCToggle,
    };
};

export { useBillToCompanyAnalyticsHandler };
